export const dotCmsPageSlugRegex = /^\/page\//;
export const dotCmsBlogSlugRegex = /\/blog\//;
export const dotCmsHomepageSlugRegex = /^\/home(?:\??[^\/]*)?$/;
export const dotCmsRouterUrlRegex = /^\/?(page\/)?(.*?)(?:\/index)?$/;
